import { useEffect } from "react";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Problem } from "@/components/landing/Problem";
import { Audience } from "@/components/landing/Audience";
import { Areas } from "@/components/landing/Areas";
import { Difference } from "@/components/landing/Difference";
import { MoreChecks } from "@/components/landing/MoreChecks";
import { PlatformCoverage } from "@/components/landing/PlatformCoverage";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ReportPreview } from "@/components/landing/ReportPreview";
import { Pricing } from "@/components/landing/Pricing";
import { References } from "@/components/landing/References";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { useT } from "@/content/landing";

const title = "Positivup — Sichtbarkeit bei Google und in KI-Antworten prüfen";
const description =
  "Kostenloser Sichtbarkeits-Check für lokale Unternehmen: Google-Maps-Position, Heatmap, Bewertungen, Rechte-Check und KI-Sichtbarkeit in einem Score. Ausführlicher Bericht 39 € einmalig.";

export default function Landing() {
  const t = useT();

  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <a
        href="#leistungen"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-[#0F172A]"
      >
        {t.ui.skipToContent}
      </a>
      <Header />
      <main>
        <Hero />
        <Problem />
        <Audience />
        <Areas />
        <Difference />
        <MoreChecks />
        <PlatformCoverage />
        <HowItWorks />
        <ReportPreview />
        <Pricing />
        <References />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
